// Color de identidad del módulo Proyecto.
export const PROYECTO_COLOR = "#5e35b1";
